import { useState } from 'react'
import { useAccount } from '@corratech/pylot-auth-manager'
import { graphqlFetch, GraphqlFetchOutput } from '@pylot-data/graphqlFetch'
import { UPDATE_SUBSCRIPTION } from '../graphql/updateSubscription'
import { Customer, Maybe } from '@pylot-data/fwrdschema'
import { useRouter } from 'next/router'

export interface NewsletterVariableInterface {
    subscription_channels?: Maybe<string>
}

export interface NewsletterOutputInterface {
    updateCustomerV2: {
        customer: Customer
    }
}

export interface UseNewsletterSubscriptionInterface {
    updateSubscription: (
        formInput: NewsletterVariableInterface
    ) => Promise<GraphqlFetchOutput<NewsletterOutputInterface>>
    isLoading: boolean
}

export const useNewsletterSubscription = (): UseNewsletterSubscriptionInterface => {
    const [isLoading, setIsLoading] = useState(false)
    const { mutate } = useAccount()
    const { locale } = useRouter()

    const updateSubscription = async (
        formInput: NewsletterVariableInterface
    ) => {
        const { subscription_channels } = formInput

        setIsLoading(true)
        const response = await graphqlFetch<
            NewsletterVariableInterface,
            NewsletterOutputInterface
        >({
            query: UPDATE_SUBSCRIPTION,
            variables: {
                subscription_channels
            },
            locale
        })

        //check if the subscription value can be update without request
        //mutateCustomer(formatted[response], false)
        await mutate()
        setIsLoading(false)

        return response
    }

    return {
        isLoading,
        updateSubscription
    }
}
